import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import s from './Header.module.css';
import { ReactComponent as LogoIcon } from '../../assets/icons/logo.svg';
import { ContactModal } from '../ContactModal/ContactModal';
import { ReactComponent as RowLeftIcon } from '../../assets/icons/ArrowLeftIcon.svg';

export const Header: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const isContactsPage = location.pathname === '/contacts';
    const isNewsItemPage = location.pathname.match(/^\/news\/\d+$/);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleContactClick = () => {
        setIsModalOpen(true);
        closeMenu();
    };

    return (
        <>
            <header className={s.header}>
                {isNewsItemPage ? (
                    <>
                        <button onClick={() => navigate('/news')} className={s.backArrow}>
                            <RowLeftIcon />
                        </button>
                        <span className={s.centerTitle}>Новости</span>
                        <div className={s.contactHidden} />
                    </>
                ) : (
                    <>
                        <Link to="/" className={s.logo}>
                            <LogoIcon className={s.logoIcon} />
                        </Link>

                        {/* Навигация по центру */}
                        <nav className={s.navDesktop}>
                            <Link to="/" className={s.navLink}>Проекты</Link>
                            <Link to="/news" className={s.navLink}>Новости</Link>
                            <Link to="/contacts" className={s.navLink}>Контакты</Link>
                        </nav>

                        {/* Кнопка "Связаться" справа */}
                        {!isContactsPage && (
                            <div className={s.contactDesktop} onClick={() => setIsModalOpen(true)}>
                                Связаться
                            </div>
                        )}

                        {/* Бургер-меню (только на мобильных) */}
                        <button
                            className={`${s.burgerButton} ${isMenuOpen ? s.burgerActive : ''}`}
                            onClick={toggleMenu}
                            aria-label="Меню"
                        >
                            <span className={s.burgerLine}></span>
                            <span className={s.burgerLine}></span>
                            <span className={s.burgerLine}></span>
                        </button>
                    </>
                )}
            </header>

            <div className={`${s.mobileMenu} ${isMenuOpen ? s.mobileMenuOpen : ''}`}>
                <nav className={s.navMobile}>
                    <Link to="/" className={s.mobileNavLink} onClick={closeMenu}>Проекты</Link>
                    <Link to="/news" className={s.mobileNavLink} onClick={closeMenu}>Новости</Link>
                    <Link to="/contacts" className={s.mobileNavLink} onClick={closeMenu}>Контакты</Link>
                    <div className={s.mobileDivider}></div>
                    <div className={s.mobileContact} onClick={handleContactClick}>
                        Связаться
                    </div>
                </nav>
            </div>

            <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};